import { render, staticRenderFns } from "./Astrolabe.vue?vue&type=template&id=36089ced&scoped=true&"
import script from "./Astrolabe.vue?vue&type=script&lang=js&"
export * from "./Astrolabe.vue?vue&type=script&lang=js&"
import style0 from "./Astrolabe.vue?vue&type=style&index=0&id=36089ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36089ced",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36089ced')) {
      api.createRecord('36089ced', component.options)
    } else {
      api.reload('36089ced', component.options)
    }
    module.hot.accept("./Astrolabe.vue?vue&type=template&id=36089ced&scoped=true&", function () {
      api.rerender('36089ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Astrolabe.vue"
export default component.exports